// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { push } from 'react-router-redux'

const setAndGoToCurrentEntity = (dbSet, entityId) => dispatch => (
  dispatch(push(`/database-management/${dbSet}/${entityId}`))
)

export default setAndGoToCurrentEntity
